import { useEffect } from 'react';
import { initCoreWebVitals } from '@/lib/analytics/CoreWebVitals';

/**
 * Web Vitals Reporter Component
 * 
 * Side-effect only component that initializes Core Web Vitals monitoring.
 * Should be rendered once at the app root level.
 * 
 * Tracks:
 * - LCP (Largest Contentful Paint)
 * - FID (First Input Delay)
 * - CLS (Cumulative Layout Shift)
 * - TTFB (Time to First Byte)
 * - INP (Interaction to Next Paint)
 * 
 * Metrics are automatically sent to Google Analytics if gtag is available.
 */
export function WebVitalsReporter() {
  useEffect(() => {
    // Initialize Core Web Vitals monitoring
    initCoreWebVitals((metric) => {
      // Optional: Additional handling for specific metrics
      if (metric.rating === 'poor') {
        console.warn(`[Performance Warning] ${metric.name} is in poor range:`, {
          value: metric.value,
          pathname: metric.pathname,
        });
      }
    });
  }, []);

  // This component renders nothing
  return null;
}
